import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const HeaderStyled = css`
  position: relative;
  height: 500px;
  ${mediaQuery('desktop')} {
    height: 400px;
  }
  ${mediaQuery('tablet')} {
    height: 300px;
  }
  ${mediaQuery('small')} {
    height: auto;
  }
`;

export const HeaderDecorationImage = styled.img`
  position: absolute;
  width: 100%;
  height: auto;
  bottom: 0;
  right: 0;
  left: 0;
  user-select: none;
  pointer-events: none;
  ${mediaQuery('small')} {
    display: none;
  }
`;
